import { MerchantUserDto, MerchantUserStatus } from "@/models/club";
import { useGetImage } from "@/utilities/helper/getImage";
import {
  ActionIcon,
  Alert,
  Avatar,
  Group,
  Menu,
  Stack,
  Text,
  Badge,
} from "@mantine/core";
import { IconAlertCircle, IconDotsVertical } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export type Team = {
  id: number;
  name: string;
  phoneNumber: string;
  profileImage: string;
  description: string;
  firstName: string;
  lastName: string;
};

type Props = {
  team: MerchantUserDto;
  setSelectedItem: (e: MerchantUserDto) => void;
  open: () => void;
  menuItems: () => JSX.Element;
  isSmall: boolean;
};

function TeamItem({ team, setSelectedItem, open, menuItems, isSmall }: Props) {
  const navigate = useNavigate();
  const { imageUrl } = useGetImage({ image: team?.image });

  return (
    <>
      <Group
        justify="space-between"
        styles={{
          root: {
            cursor: "pointer",
          },
        }}
      >
        <Group
          justify="space-between"
          onClick={() =>
            navigate(`/dashboard/teams/teamMembers/detail/${team?.id}`)
          }
        >
          <Group>
            <Avatar
              variant="outline"
              color="blue"
              radius="xl"
              size="lg"
              src={imageUrl}
              p="3"
              styles={{
                image: {
                  borderRadius: "100px",
                },
                root: {
                  border: `3px solid ${team?.calendarColor}`,
                },
              }}
            >
              {team?.firstName?.charAt(0) || ""}
            </Avatar>

            <Stack gap="0">
              <Text size="md">
                {team.firstName} {team?.lastName}
              </Text>
              {team?.status === MerchantUserStatus.Value0 && (
                <Alert color="yellow" px="0" py="2">
                  <Group gap={5}>
                    <IconAlertCircle stroke={1} size={15} />
                    <Text size="10px" fw="lighter">
                      در انتظار قبول دعوت نامه
                    </Text>
                  </Group>
                </Alert>
              )}

              {(team as { isChairRenter?: boolean })?.isChairRenter && (
                <Badge size="xs" variant="light" color="violet" w="fit-content">اجاره‌ای · حساب جدا</Badge>
              )}
              {team?.jobTitle || team?.jobTitle !== "undefined" ? (
                <Text size="xs" c="gray">
                  {team?.jobTitle || ""}
                </Text>
              ) : null}
            </Stack>
          </Group>
        </Group>
        {isSmall ? (
          <Group gap="2" justify="end">
            <ActionIcon
              variant="transparent"

              onClick={() => {
                setSelectedItem(team);
                open();
              }}
            >
              <IconDotsVertical />
            </ActionIcon>
          </Group>
        ) : (
          <Menu>
            <Menu.Target>
              <ActionIcon
                variant="transparent"
                onClick={() => setSelectedItem(team)}
              >
                <IconDotsVertical />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>{menuItems()}</Menu.Dropdown>
          </Menu>
        )}
      </Group>
    </>
  );
}

export default TeamItem;
